/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ISingleSystemSetupParameter } from './ISingleSystemSetupParameter';
import {
    ISingleSystemSetupParameterFromJSON,
    ISingleSystemSetupParameterFromJSONTyped,
    ISingleSystemSetupParameterToJSON,
} from './ISingleSystemSetupParameter';

/**
 * 
 * @export
 * @interface TaskItemQaEquipmentSetupDto
 */
export interface TaskItemQaEquipmentSetupDto {
    /**
     * 
     * @type {string}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    name?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    supportSystemEntityIds?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    isSingleSetupParameterListReadOnly?: boolean;
    /**
     * 
     * @type {Array<ISingleSystemSetupParameter>}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    singleSetupParameters?: Array<ISingleSystemSetupParameter> | null;
    /**
     * 
     * @type {string}
     * @memberof TaskItemQaEquipmentSetupDto
     */
    $type?: TaskItemQaEquipmentSetupDtoTypeEnum;
}


/**
 * @export
 */
export const TaskItemQaEquipmentSetupDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoTaskItemQaEquipmentSetupDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.TaskItemQaEquipmentSetupDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TaskItemQaEquipmentSetupDtoTypeEnum = typeof TaskItemQaEquipmentSetupDtoTypeEnum[keyof typeof TaskItemQaEquipmentSetupDtoTypeEnum];


/**
 * Check if a given object implements the TaskItemQaEquipmentSetupDto interface.
 */
export function instanceOfTaskItemQaEquipmentSetupDto(value?: unknown): value is TaskItemQaEquipmentSetupDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TaskItemQaEquipmentSetupDtoTypeEnum)[0];
}

export function TaskItemQaEquipmentSetupDtoFromJSON(json: any): TaskItemQaEquipmentSetupDto {
    return TaskItemQaEquipmentSetupDtoFromJSONTyped(json, false);
}

export function TaskItemQaEquipmentSetupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskItemQaEquipmentSetupDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'supportSystemEntityIds': !exists(json, 'supportSystemEntityIds') ? undefined : json['supportSystemEntityIds'],
        'isSingleSetupParameterListReadOnly': !exists(json, 'isSingleSetupParameterListReadOnly') ? undefined : json['isSingleSetupParameterListReadOnly'],
        'singleSetupParameters': !exists(json, 'singleSetupParameters') ? undefined : (json['singleSetupParameters'] === null ? null : (json['singleSetupParameters'] as Array<any>).map(ISingleSystemSetupParameterFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function TaskItemQaEquipmentSetupDtoToJSON(value?: TaskItemQaEquipmentSetupDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'supportSystemEntityIds': value.supportSystemEntityIds,
        'isSingleSetupParameterListReadOnly': value.isSingleSetupParameterListReadOnly,
        'singleSetupParameters': value.singleSetupParameters === undefined ? undefined : (value.singleSetupParameters === null ? null : (value.singleSetupParameters as Array<any>).map(ISingleSystemSetupParameterToJSON)),
        '$type': value.$type,
    });
}

